import AllPatern from './AllPatern';
export default AllPatern;
